// =============================================================================
// features/crm/components/FilterToggleChip.tsx — Chip liga/desliga dos filtros
// da lista do CRM (F58-S08). Mesma linguagem visual dos filtros rápidos
// (CrmQuickFilters): pílula, ativo = azul/10 + borda azul + check.
//
// Hover responde ao toque (borda forte), active "afunda" 1px, focus visível
// com ring azul, disabled com opacidade — os 4 estados do DS.
// =============================================================================

import * as React from 'react';

import { cn } from '../../../lib/cn';

interface FilterToggleChipProps {
  label: string;
  pressed: boolean;
  onToggle: () => void;
  title?: string | undefined;
  disabled?: boolean | undefined;
  /** Ícone à esquerda quando NÃO ativo (ativo mostra o check). */
  icon?: React.ReactNode;
}

export function FilterToggleChip({
  label,
  pressed,
  onToggle,
  title,
  disabled,
  icon,
}: FilterToggleChipProps): React.JSX.Element {
  return (
    <button
      type="button"
      aria-pressed={pressed}
      disabled={disabled}
      title={title}
      onClick={onToggle}
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1.5 min-h-[32px] rounded-pill',
        'font-sans text-xs font-semibold',
        'border transition-all duration-fast ease-out active:translate-y-px',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-azul/30',
        'disabled:opacity-40 disabled:cursor-not-allowed',
        pressed
          ? 'bg-azul/10 border-azul text-azul shadow-e1'
          : 'bg-[var(--bg-elev-1)] border-border-subtle text-ink-3 hover:text-ink hover:border-border-strong',
      )}
    >
      {pressed ? (
        <svg
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          className="w-3 h-3 shrink-0"
          aria-hidden="true"
        >
          <path d="M3 8.5l3 3 7-7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        icon
      )}
      {label}
    </button>
  );
}
